import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-24 bg-neutral-900 text-white relative overflow-hidden bg-cover bg-center" style={{
    backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/my7z2UYeBJenJ2RfbxkFfG/taekwondo-team.png)'
  }} data-id="element-40">
      {/* Dark overlay for text visibility */}
      <div className="absolute inset-0 bg-neutral-900/80 z-0" data-id="element-41"></div>

      <div className="container mx-auto px-4 relative z-10 text-center max-w-3xl" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-43">
          <h2 className="text-4xl md:text-6xl font-black mb-6 tracking-tight" data-id="element-44">
            Start Your Taekwondo Journey Today
          </h2>
          <p className="text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-45">
            Getting started is simple. Sign up today and take the first step
            toward confidence, fitness, and personal growth.
          </p>{' '}
          <Button className="text-xl px-12 py-6 shadow-red-900/50" href="/signup" data-id="element-46" />
        </motion.div>
      </div>
    </section>;
}